import React, { PropTypes } from 'react';
import { icon } from './../../../../icons/icons';

const OptionTool = (props) => {
    const { option, optionsList, onValueChange, deleteRadio } = props;
    return (
        <div key={option.id} className="choice__row">
            <input type="text" defaultValue={option.label} onChange={onValueChange} />
            { (optionsList.length > 2) ? <div className="choice__delete icon" title="Delete" onClick={deleteRadio}>{icon.thrash()}</div> : null }
        </div>
    );
};

OptionTool.propTypes = {
    option: PropTypes.object.isRequired,
    optionsList: PropTypes.array.isRequired,
    onValueChange: PropTypes.func.isRequired,
    deleteRadio: PropTypes.func.isRequired,
};

export default OptionTool;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Tools/Widgets/Choice/OptionTool.jsx